import type { ComponentProps } from 'react';
import { FieldInfo, useFieldContext } from './shared';
import { Label } from '../label';
import { Input } from '../input';

export default function FileField({ label, className, ...props }: ComponentProps<'input'> & { label: string }) {
	const field = useFieldContext<File | undefined>();

	return (
		<div className={className}>
			<div className="text-muted-foreground dark:bg-input/30 dark:hover:bg-input/50 border-input relative rounded-md border bg-transparent shadow-xs transition-colors">
				{label && (
					<Label
						data-slot="form-label"
						data-error={field.state.meta.isTouched && !field.state.meta.isValid}
						className="data-[error=true]:text-destructive floating pointer-events-none w-full truncate px-3.5 py-[17px]"
						htmlFor={field.name}
					>
						{label}
					</Label>
				)}
				<Input
					type="file"
					id={field.name}
					name={field.name}
					ref={(ref) => {
						if (!ref) return;
						if (!field.state.value) return;
						if (!(field.state.value instanceof File)) return;

						// Create FileList so we can restore persisted file on input
						const dataTransfer = new DataTransfer();
						dataTransfer.items.add(field.state.value);
						ref.files = dataTransfer.files;
					}}
					onChange={(event) => {
						const file = event.target.files?.[0];

						field.handleChange(file);
						if (!file) return;
					}}
					className="text-foreground h-12 px-3 pt-4 pb-0"
					{...props}
				/>
			</div>
			<FieldInfo fieldState={field.state} />
		</div>
	);
}
